import { PROJECT_D2D } from "../../constants/projectVersion";
import { DIMM_DDR_TYPES } from "./constants";

export const PROJECT_INDEX = 2,
  TRASH_INDEX = 3,
  DESIGN_INDEX = 0,
  PACKAGE_INDEX = 1,
  CARD_INDEX = 2,
  INTERPOSER_INDEX = 0;

function getChannelIndex(type, projectVersion) {
  if (DIMM_DDR_TYPES.includes(type) || projectVersion === PROJECT_D2D) {
    return 3;
  }
  return 2;
}

function getPCBIndex(projectVersion) {
  if (projectVersion === PROJECT_D2D) {
    return 2;
  }
  return 0;
}

export {
  getChannelIndex,
  getPCBIndex
}